import { createContext, ReactNode, useCallback, useContext, useState } from 'react';
import { ColumnSize, readColumnSizeFromStorage, writeColumnSizeToStorage } from './utils';

/**
 * V2-only column-size state. Kept out of the shared gdprColumnSize Redux slice so that
 * V2-specific values (e.g. 4 columns) can't leak into V1, whose zoom control only
 * supports 1-3.
 */
interface ColumnSizeContextValue {
  columnSize: ColumnSize;
  setColumnSize: (value: ColumnSize) => void;
}

const ColumnSizeContext = createContext<ColumnSizeContextValue | null>(null);

export const ColumnSizeProvider = ({ children }: { children: ReactNode }) => {
  const [columnSize, setColumnSizeState] = useState<ColumnSize>(() => readColumnSizeFromStorage());

  const setColumnSize = useCallback((value: ColumnSize) => {
    setColumnSizeState(value);
    writeColumnSizeToStorage(value);
  }, []);

  return <ColumnSizeContext.Provider value={{ columnSize, setColumnSize }}>{children}</ColumnSizeContext.Provider>;
};

export const useColumnSize = (): ColumnSizeContextValue => {
  const ctx = useContext(ColumnSizeContext);
  if (!ctx) throw new Error('useColumnSize must be used within a ColumnSizeProvider');
  return ctx;
};
